import {
  AccountantsViewActions,
  EAccountantsViewActions,
} from '@myStore/accountants/view/accountants-view.actions';
import {
  IAccountantsViewState,
  initialsAccountantsViewState,
} from '@myStore/accountants/view/accountants-view.state';

export const accountantsViewReducers = (
  state = initialsAccountantsViewState,
  actions: AccountantsViewActions
): IAccountantsViewState => {
  switch (actions.type) {
    case EAccountantsViewActions.GetCardsRequest:
      return {
        ...state,
        cards: {
          data: null,
          isLoading: true,
        },
      };
    case EAccountantsViewActions.GetCardsSuccess:
      return {
        ...state,
        cards: {
          data: actions.data,
          isLoading: false,
        },
      };
    case EAccountantsViewActions.GetCardsFailure:
      return {
        ...state,
        errors: actions.errors,
        cards: {
          data: null,
          isLoading: false,
        },
      };
    case EAccountantsViewActions.ClearGetCards:
      return {
        ...state,
        errors: null,
        cards: {
          data: null,
          isLoading: false,
        },
      };
  }
  return state;
};
